import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { TooltipProvider } from './ui/tooltip';
import { InlineEditableText } from './InlineEditableText';

interface EditableResourceHeaderProps {
  resourceTitle: string;
  resourcesPath: string;
  onResourceTitleChange: (title: string) => void | boolean | Promise<void | boolean>;
  readOnly?: boolean;
}

export const EditableResourceHeader: React.FC<EditableResourceHeaderProps> = ({
  resourceTitle,
  resourcesPath,
  onResourceTitleChange,
  readOnly = false,
}) => {
  const { t } = useLocale();
  const displayTitle = resourceTitle || t('untitled');

  return (
    <TooltipProvider>
      <div className="flex min-w-0 flex-1 items-center overflow-hidden">
        <nav className="flex min-w-0 flex-1 items-center gap-2 overflow-hidden">
          <Link
            to={resourcesPath}
            className="no-underline hover:no-underline text-muted-foreground hover:bg-accent hover:text-primary"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.25rem',
              fontSize: '14px',
              fontWeight: 400,
              whiteSpace: 'nowrap',
              flexShrink: 0,
              borderRadius: '0.375rem',
              padding: '4px 8px 4px 4px',
              margin: '-4px -8px -4px -4px',
            }}
          >
            <ArrowLeft size={12} style={{ flexShrink: 0, paddingLeft: '4px', marginRight: '4px' }} />
            {t('Resources')}
          </Link>
          <span style={{ color: 'var(--muted-foreground)', fontSize: '14px', flexShrink: 0 }}>/</span>
          <div className="min-w-0 flex-1 overflow-hidden">
            <InlineEditableText
              value={resourceTitle}
              onCommit={onResourceTitleChange}
              savedFieldLabel={t('title')}
              readOnly={readOnly}
              placeholder={t('untitled')}
              tooltip={readOnly ? displayTitle : undefined}
              className="truncate leading-normal text-lg font-bold text-foreground"
              inputClassName="text-lg font-bold"
            />
          </div>
        </nav>
      </div>
    </TooltipProvider>
  );
};
